/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { WindowInsetCombinationDeclarationDto } from "./WindowInsetCombinationDeclarationDto";

export class AreaFragmentCombinationDeclarationDto {
    sort: number;
    flex: number | null;
    fixedWidth: number | null;
    windowInsetCombinationDeclarations: WindowInsetCombinationDeclarationDto[];
}
